<script>
import { useId } from 'vue';

export default {
    setup() {
        return {
            id: useId()
        }
    },
    emits: [
        'update:modelValue'
    ],
    props: {
        modelValue: {
            default: null
        },
        element: {
            type: String,
            default: 'p'
        },
        color: {
            type: String,
            default: 'gray'
        },
        showLabel: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
            required: true
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
        getColor() {
            if(this.$attrs.disabled) return 'bg-bhav-cool-gray-50';
            switch(this.color) {
                case 'white' :
                    return 'bg-white hover:bg-transparent border-transparent'
                case 'gray' :
                default :
                    return 'bg-bhav-cool-gray-50 border-transparent group-hover:border-bhav-cool-gray-100 hover:bg-white hover:border-white group-hover:hover:border-white'
            }
        },
        checked() {
            let value = this.$attrs?.value ?? null
            if(Array.isArray(this.value)) {
                if(Array.isArray(value)) {
                    return this.value.sort((a,b) => a > b ? 1 : -1).join(',') === value.sort((a,b) => a > b ? 1 : -1).join(',')
                } else {
                    return this.value.includes(value)
                }
            } else {
                return this.value === value;
            }
        }
    }
}
</script>

<template>
<component :is="element" class="flex gap-2">
    <span class="grid w-6 h-6 min-w-6 min-h-6">
        <input :id="id" type="checkbox" v-model="value" v-bind="$attrs"
               class="appearance-none rounded-lg w-6 h-6 min-w-6 min-h-6 border col-start-1 row-start-1"
               :class="[getColor, $attrs.disabled ? 'cursor-not-allowed' : 'cursor-pointer']"/>
        <i v-if="checked || $attrs.checked"
           class="fak fa-check col-start-1 row-start-1 self-center justify-self-center pointer-events-none text-sm leading-none"></i>
    </span>
    <label :for="id" :class="[$attrs.disabled ? 'text-bhav-blue-200' : 'text-bhav-blue-500', {'sr-only' : !this.showLabel}]">{{ label }}</label>
</component>
</template>